import { Place } from "../../../types/global"
import * as S from "../styles"
import Resizer from "react-image-file-resizer"

interface ImagesProps {
  currentPlace: Place
  setCurrentPlace: Function
  imagesNew: any[]
  setImagesNew: Function
  uploadProgress: number
  imagesToRemove: any[]
  setImagesToRemove: Function
  loading: boolean
  setLoading: Function
}

export default function Images({
  currentPlace,
  setCurrentPlace,
  imagesNew,
  setImagesNew,
  uploadProgress,
  imagesToRemove,
  setImagesToRemove,
  loading,
  setLoading,
}: ImagesProps) {
  const handleRemoveDbImageClick = (
    e: React.MouseEvent<HTMLImageElement>,
    key: number,
  ) => {
    setImagesToRemove([
      ...imagesToRemove,
      { placeId: currentPlace.id, src: (e.target as HTMLImageElement).src },
    ])
    let imagesTemp = currentPlace.images
    imagesTemp?.splice(key, 1)
    setCurrentPlace({ ...currentPlace, images: imagesTemp })
  }

  const handleRemoveTempImageClick = (key: number) => {
    let imagesTemp = imagesNew
    imagesTemp.splice(key, 1)
    setImagesNew([...imagesTemp])
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e?.target?.files?.[0]) {
      setLoading(true)
      const imageFile = await resizeFile(e.target.files[0])
      const imageBase64 = await resizeBase64(e.target.files[0])
      setImagesNew([...imagesNew, { file: imageFile, base64: imageBase64 }])
      setLoading(false)
    }
  }

  return (
    <>
      <h2>Vložit fotku</h2>
      <S.ImageContainer>
        {currentPlace?.images &&
          currentPlace.images.map((image, key) => (
            <S.ImageWrapper key={key}>
              <S.Image
                src={"https://" + image}
                alt={"image " + key}
                onClick={(e) => handleRemoveDbImageClick(e, key)}
              />
            </S.ImageWrapper>
          ))}

        {imagesNew.map((image, key) => (
          <S.ImageWrapper key={"tempImage" + key}>
            <S.Image
              src={image.base64}
              alt={"image " + key}
              onClick={() => handleRemoveTempImageClick(key)}
            />
          </S.ImageWrapper>
        ))}

        {
          // Images doesnt exists in db OR more then 5 images in db
          (typeof currentPlace?.images === "undefined" ||
            currentPlace.images.length + imagesNew.length < 5) && (
            <label>
              <S.ImagePlaceholder>
                {uploadProgress && uploadProgress < 100 ? (
                  uploadProgress
                ) : loading ? (
                  <S.Spin>↻</S.Spin>
                ) : (
                  "+"
                )}
              </S.ImagePlaceholder>
              <S.HiddenInput
                type="file"
                id="file"
                onChange={handleFileChange}
                accept="image/*"
              />
            </label>
          )
        }
      </S.ImageContainer>
    </>
  )
}

const resizeBase64 = async (file: File) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1024,
      1024,
      "JPEG",
      90,
      0,
      (uri) => {
        resolve(uri)
      },
      "base64",
    )
  })

const resizeFile = async (file: File) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1024,
      1024,
      "JPEG",
      90,
      0,
      (uri) => {
        resolve(uri)
      },
      "file",
    )
  })
